import { useMemo, useState } from "react";
import { Card, SectionHeader, TextInput } from "../../components/lib";
import { DocumentActions } from "../../components/DocumentActions";
import { TabBar, ListRow } from "../../components/lib.overlay";
import { PRE_LAUNCH_CAMPAIGNS, LAUNCH_PROJECTS, PreLaunchCampaign } from "../../mocks/launchData";

const STATUS_META: Record<PreLaunchCampaign["status"], { bg: string; fg: string }> = {
  live:      { bg: "var(--ph-success-tint)", fg: "var(--ph-success)"  },
  scheduled: { bg: "var(--ph-ai-tint)",       fg: "var(--ph-ai)"       },
  complete:  { bg: "var(--ph-neutral-tint)", fg: "var(--ph-ink-muted)" },
};
function launchName(id: string) { return LAUNCH_PROJECTS.find((l) => l.id === id)?.productName ?? id; }

export default function Campaigns() {
  const [tab, setTab] = useState<PreLaunchCampaign["status"] | "all">("all");
  const [q, setQ] = useState("");
  const filtered = useMemo(() => PRE_LAUNCH_CAMPAIGNS.filter((c) =>
    (tab === "all" || c.status === tab) &&
    (!q || c.name.toLowerCase().includes(q.toLowerCase()) || launchName(c.launchId).toLowerCase().includes(q.toLowerCase())),
  ), [tab, q]);

  return (
    <div className="space-y-6" data-testid="ln-campaigns">
      <Card testId="ln-cm-filters">
        <TextInput value={q} onChange={setQ} placeholder="Search pre-launch campaigns…" testId="ln-cm-search" />
        <div className="mt-4">
          <TabBar<PreLaunchCampaign["status"] | "all">
            testId="ln-cm-tabs"
            active={tab}
            onChange={setTab}
            tabs={[
              { key: "all",       label: "All"       },
              { key: "live",      label: "Live"      },
              { key: "scheduled", label: "Scheduled" },
              { key: "complete",  label: "Complete"  },
            ]}
          />
        </div>
      </Card>

      <Card padded={false} testId="ln-cm-list-card">
        <div className="p-5" style={{ borderBottom: "1px solid var(--ph-border-subtle)" }}>
          <SectionHeader eyebrow="Campaigns" title={`${filtered.length} campaign${filtered.length === 1 ? "" : "s"}`} />
          <DocumentActions docKey="campaign-report" testId="camp-doc-actions" />
        </div>
        <div className="p-2">
          {filtered.map((c) => {
            const m = STATUS_META[c.status];
            return (
              <ListRow key={c.id} testId={`ln-c-${c.id}`}
                label={<span className="inline-flex items-center gap-2">{c.name}
                  <span className="px-1.5 py-0.5 text-[9px] font-semibold uppercase" style={{ letterSpacing: "0.14em", background: m.bg, color: m.fg, borderRadius: "var(--ph-radius-sm)" }}>{c.status}</span>
                </span>}
                sublabel={<>{launchName(c.launchId)} · {c.kind} · reach {(c.reach/1000).toFixed(1)}K · {c.subscribed} subs · {c.runsRelative}</>}
                trailing={<div className="text-right"><div className="text-sm tabular-nums" style={{ color: "var(--ph-ink-strong)" }}>EGP {(c.spentEGP/1000).toFixed(0)}K / {(c.budgetEGP/1000).toFixed(0)}K</div></div>}
              />
            );
          })}
        </div>
      </Card>
    </div>
  );
}
